import React from 'react'
import { APPConfig } from 'config/appConfig'
import { customerContainer } from 'src/models/Customer'
import { accountsContainer } from 'src/models'
import MySiteAdminCatalog from '../MySiteAdmin/MySiteAdminCatalog'
import MultipleSubscriptions from '../MyAccount/MultipleSubscriptions/MultipleSubscriptions'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { trackSplunkCustomEvent } from 'src/utils/splunk'
import { pageNames } from 'src/routes/pathParams'
import { PUBSUB } from 'src/pubsub/pubEventNames'
import { subscribe, unSubscribeEvent } from 'src/pubsub'
import { enableHeaderMFE } from 'src/utils'
import { isFetchAllPromoCodeEnabled } from 'src/deps/MyAccountMenuDeps'
import MyAccountMFE from './MyAccountMFE'

const MYACCOUNTS_REMOTE_CONFIG = { appName: 'account-mfe', component: 'App' }
const ACCOUNT_PROFILE_SHELL_REMOTE_CONFIG = {
  appName: 'account-profile',
  component: 'MyAccount',
}

class MyAccountMFEContainer extends React.Component {
  subscriptions = []

  subscribeToEvent = (eventName, handler) =>
    subscribe(eventName, async (...args) => {
      try {
        await handler(...args)
      } catch (error) {
        trackSplunkCustomEvent({
          eventName: 'myaccounts_pubsub_subscriber_error',
          attributes: {
            eventName,
            error: error?.message || String(error),
          },
        })
      }
    })

  componentDidMount() {
    const subscriptions = [
      this.subscribeToEvent(PUBSUB.RESET_PASSWORD, this.handleResetPassword),
      this.subscribeToEvent(
        PUBSUB.ACCOUNT_CONVERSION,
        this.handleAccountConversion
      ),
      this.subscribeToEvent(
        PUBSUB.BA_CONVERSION_COMPLETED,
        this.handleCustomerProfileRefresh
      ),
      this.subscribeToEvent(
        PUBSUB.CUSTOMER_PROFILE_UPDATED,
        this.handleCustomerProfileRefresh
      ),
    ]

    if (!enableHeaderMFE()) {
      subscriptions.unshift(
        this.subscribeToEvent(
          PUBSUB.INTERNAL_ROUTING,
          this.handleInternalRouting
        )
      )
    }

    this.subscriptions = subscriptions
  }

  componentWillUnmount() {
    this.subscriptions.forEach(token => unSubscribeEvent(token))
    this.subscriptions = []
  }

  getFeatureFlags = () => APPConfig.getAppConfig() || {}

  getParams = () => {
    const params = {
      routerHistory: this.props.history,
      customerData: customerContainer.profileResponse,
      featureFlags: this.getFeatureFlags(),
      isFetchAllPromoCodeEnabled: isFetchAllPromoCodeEnabled(),
      locale: getLocaleCodeFromUrl({
        url: typeof window === 'object' ? window.location.href : '',
        at: 'pathParam',
        defaultLocale: 'en_US',
        isReverseType: true,
      }),
      // Storefront-native components that account-profile-mfe MFE-compose routes require.
      // Passed as class references (not elements) — instantiated only when the target route renders.
      hostComponents: {
        MySiteAdminCatalog,
        // MobX @observer class that owns the full subscription UI + subscription MFE loading.
        // account-profile-mfe injects React Router v5 shims (history/location/match) at render time.
        MultipleSubscriptions,
      },
    }
    // The account-profile full-shell MFE (Next.js) can't share the host router,
    // so it derives the active content page + active nav highlight from this path.
    // Recomputed on every render → shell swaps content on navigation without remount.
    if (this.props.includeCurrentPath) {
      const path = this.props.history?.location?.pathname
      if (path) params.currentPath = path
    }
    return params
  }

  handleInternalRouting = (_, data = {}) => {
    if (data?.path) {
      this.props.history.push(data.path)
    }
  }

  handleResetPassword = async () => {
    await customerContainer.logout()
    const { oktaDomain } = APPConfig.getAppConfig()

    if (typeof window === 'object' && oktaDomain) {
      window.location.replace(`${oktaDomain}/signin/forgot-password`)
    }
  }

  handleAccountConversion = (_, data = {}) => {
    if (data?.accountType === 'convertToBA') {
      this.props.history.push(pageNames.BAAccountConversionForIN)
    } else if (data?.accountType === 'convertToVDI') {
      this.props.history.push(pageNames.VDIConversionForFR)
    }
  }

  handleCustomerProfileRefresh = async () => {
    accountsContainer.isSyncingAfterConversion = true
    try {
      await customerContainer.getProfile()
      if (customerContainer?.accountId) {
        await accountsContainer.getProfile(customerContainer.accountId)
      }
    } finally {
      accountsContainer.isSyncingAfterConversion = false
    }
  }

  render() {
    return (
      <MyAccountMFE
        remoteConfig={this.props.remoteConfig || MYACCOUNTS_REMOTE_CONFIG}
        params={this.getParams()}
      />
    )
  }
}

export {
  MyAccountMFEContainer,
  MYACCOUNTS_REMOTE_CONFIG,
  ACCOUNT_PROFILE_SHELL_REMOTE_CONFIG,
}
export default MyAccountMFEContainer
